export enum SupportMessageRole {
  USER = 'User',
  ASSISTANT = 'Assistant'
}

export enum SupportConversationStatus {
  OPEN = 'Open',
  RESOLVED = 'Resolved',
  ESCALATED = 'Escalated'
}

export enum SupportEscalationChannel {
  TICKET = 'Ticket',
  EMAIL = 'Email'
}
